import configuredi18n from './i18n.config'

export default configuredi18n
